import angular from 'angular';
import 'angular-ui-grid';
import OrderHistoryListComponent from '../orderHistoryListWrapper//order.history.list.component';
import { routing as OrderHistoryListWrapperConfig } from './order.history.list.wrapper.config';
export default angular.module('inv.customer.orderHistoryListWrapper', []).component('orderHistoryList', OrderHistoryListComponent).config(OrderHistoryListWrapperConfig).name;